<div class="flex items-center gap-2">
  <p class="font-bold text-[16px] leading-[24px] tracking-[0.005em] text-center mr-2" id="header-ballot-type-label">{{ ballotTypeLabel }}</p>
  <span class="relative -translate-y-1">
    <app-ballot-type-badge [ballotType]="ballotType"></app-ballot-type-badge>
  </span>
</div>
